import {
  Button,
  HStack,
  Icon as IconWrapper,
  Menu,
  Portal,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { Folder as FolderIcon, FolderPlus, Layout } from 'react-feather';
import { NavAccordionItemChild } from '@/components/SidebarItems/NavAccordionItemChild';
import { NewProjectModal } from '@/components/NewProjectModal';
import { ProjectsOverviewModal } from '@/components/ProjectsOverviewModal';
import { useAppSelector } from '@/lib/hooks';
import { Tooltip } from '@/components/ui/tooltip';

export const ProjectActionsDropdown = () => {
  const projectState = useAppSelector((state) => state.viewReducer);

  const newProjectModalDisclosure = useDisclosure();
  const projectsOverviewModalDisclosure = useDisclosure();

  return (
    <VStack
      className="PROJECT CONTAINER"
      style={{
        borderRadius: '0.375rem',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
      gap={2}
      padding={4}
    >
      <Menu.Root>
        <Menu.Trigger>
          <Tooltip
            content="Select the current project"
            positioning={{ placement: 'end' }}
            openDelay={500}
          >
            <HStack
              style={{
                width: 'fit-content',
                height: 'fit-content',
                borderRadius: '0.375rem',
              }}
              padding={4}
              background="accentButtonDefault"
              _hover={{ bg: 'accentButtonHover', transition: 'background-color 0.2s', cursor: "pointer" }}
              _active={{ bg: 'accentButtonActive', transition: 'background-color 0.2s' }}
            >
              <IconWrapper as={Layout} color="cardDefault" />
              <Text
                fontSize="medium"
                fontWeight={800}
                color="cardDefault"
                textAlign="center"
                cursor="pointer"
                textOverflow="ellipsis"
              >
                Project:
              </Text>
              <Text
                fontSize="medium"
                color="cardDefault"
                textAlign="center"
                cursor="pointer"
                fontStyle="italic"
                overflow="hidden"
                textOverflow="ellipsis"
                width={150}
                maxWidth={150}
              >
                {projectState.name}
              </Text>
            </HStack>
          </Tooltip>
        </Menu.Trigger>

        <Portal>
          <Menu.Positioner>
            <Menu.Content backgroundColor="cardDefault">
              <NavAccordionItemChild
                key="new_project_button"
                text="Create new Project"
                textShort="New Project"
                icon={<FolderPlus />}
                isOpen={true}
                onClick={() => newProjectModalDisclosure.setOpen(true)}
              />
              <NavAccordionItemChild
                key="open_project_button"
                text="Open Project"
                textShort="Open Project"
                icon={<FolderIcon />}
                isOpen={true}
                onClick={() => projectsOverviewModalDisclosure.setOpen(true)}
              />
              <NewProjectModal
                open={newProjectModalDisclosure.open}
                setOpen={newProjectModalDisclosure.setOpen}
              />

              <ProjectsOverviewModal
                open={projectsOverviewModalDisclosure.open}
                setOpen={projectsOverviewModalDisclosure.setOpen}
              />
            </Menu.Content>
          </Menu.Positioner>
        </Portal>
      </Menu.Root>
    </VStack>
  );
};
